import { LinkableArchiveItemResource, LinkableItemLifecycleStates, LinkableItemRef, LinkableSpecimenItemResource, StateNode } from "./workflow-schema"
import { SkinDate } from "./skin-date"

export enum MovementTypes {
    COMPLEX = 'complex',
    RETURN = 'returning',
    SIMPLE = 'simple',
}

export enum MovementLifecycleStates {
    ARCHIVED = 'archived',
    CANCELED = 'canceled',
    FINALIZED = 'finalized',
    IN_PREPARATION = 'inPreparation',
    IN_PROGRESS = 'inProgress',
    PROGRAMMED = 'programmed',
}

export interface Movement {
    id: string,
    movementSchema: {
        affectedStorekeepers: string[],
        plannedDate: PlannedDatesResource,
    },
    movementType: MovementTypes,
    workflowSchema: MovementWorkFlowSchema,
}

export interface PlannedDatesResource {
    endDate: SkinDate,
    startDate: SkinDate,
}

export interface MovementWorkFlowSchema {
    currentState?: StateNode<MovementLifecycleStates> //class LifecycleStateResource<> in Tryphon 
    linkableItems?: MovementLinkableItemStateResource[] 
    defaultItemState?: StateNode<MovementLifecycleStates> //LifecycleStateResource  
    usePermanentLocationForDestination?: boolean
    otherItem: {
        [key: string]: LinkableItemRef[]
    }
}

export interface MovementLinkableItemStateResource {
    state?: StateNode<LinkableItemLifecycleStates> //LifecycleStateResource 
    linkableItem?: LinkableArchiveItemResource | LinkableSpecimenItemResource
    arrivalLocation?: String
    modifyPermanentLocation?: Boolean
}